import { Component, computed, input } from '@angular/core';
import type { OnyxOptional } from '../../../interfaces';
import type { ButtonActionType } from '../../../internal/interfaces';
import type { OnyxIconName } from '../../icons/interfaces';
import { OnyxIconComponent } from '../../icons/onyx-icon/onyx-icon.component';
import { ICON_BUTTONS } from '../constants';
import type { IconButtonColor, IconButtonType } from '../interfaces';

@Component({
  selector: 'onyx-icon-button',
  imports: [OnyxIconComponent],
  templateUrl: './onyx-icon-button.component.html',
  styleUrl: './onyx-icon-button.component.scss',
})
export class OnyxIconButtonComponent<
  Type extends IconButtonType = IconButtonType,
  Color extends IconButtonColor<Type> = IconButtonColor<Type>,
> {
  public readonly variant = input.required<Type>();
  public readonly color = input.required<Color>();
  public readonly size = input.required<16 | 20 | 24 | 32 | 40 | 48>();
  public readonly icon = input<OnyxOptional<OnyxIconName>>();
  public readonly circle = input(false);
  public readonly pressed = input(false);
  public readonly active = input(false);
  public readonly actionType = input<ButtonActionType>('button');
  public readonly tabindex = input(0);
  public readonly disabled = input(false);
  public readonly disabledActiveHover = input(false);

  protected readonly ICON_BUTTONS = ICON_BUTTONS;

  protected iconSize = computed(() => (this.size() === 16 ? 16 : 20));
}
